// extracted by mini-css-extract-plugin
export default {"msgM":"_16b7288e83"};